
export default function ScrollToFirstErrorModule(element) {

    let firstError = element.querySelectorAll('.error-message')[0];

    if (firstError) {
        firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            // inline: 'center',
        });
    }

}